import { IconButton } from "../IconButton/IconButton";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import { CidrRange, CidrRangeProps } from "./CidrRange";
import styles from "./CidrRanges.module.less";

export type CidrRangesProps = {
	title: string;
	onAdd(): void;
	trackingId?: string;
};

export const CidrRanges = (props: PropsWithChildren<CidrRangesProps>): ReactElement => {
	const {
		title,
		onAdd,
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<h4 className={styles.title}>
				{title}
			</h4>

			<ul className={styles.list}>
				{ children }
			</ul>

			<IconButton
				kind="dashed"
				width="fill"
				icon="plus"
				onClick={onAdd}
				trackingId={generateTrackingId(trackingId, "__add")}
			/>
		</div>
	);
};
CidrRanges.displayName = "CidrRanges";

export type CidrRangeListItemProps = CidrRangeProps;

export const CidrRangeListItem = (props: CidrRangeListItemProps): ReactElement => {
	return (
		<li className={styles.item}>
			<CidrRange {...props} />
		</li>
	);
};
CidrRangeListItem.displayName = "CidrRanges.Item";

CidrRanges.Item = CidrRangeListItem;